
window._eai_r = require;
window._eai_d = define;
